var exports = {
  "P": "xe533113f--871e74--label",
};

module.exports = exports;
